<template>
  <div id="sec-essentials" class="px-3 pb-3">
    <div class="ch-section-header mb-4">
      <p class="overline mb-1">STAY</p>
      <h2 class="heading-6-1 mb-0" style="letter-spacing:-0.3px">Essentials</h2>
    </div>

    <!-- WiFi card -->
    <div v-if="wifi" class="bg-white radius-16 box-shadow-bold p-3 mb-3">
      <div class="d-flex align-items-center mb-3">
        <div class="ch-icon-box mr-3 flex-shrink-0">
          <Wifi :size="18" :stroke-width="2" />
        </div>
        <div class="flex-grow-1 overflow-hidden">
          <p class="ch-meta-label mb-1">Wi-Fi Network</p>
          <p class="mb-0 body-2-1 text-truncate">{{ wifi.network }}</p>
        </div>
      </div>
      <div class="ch-wifi-pass d-flex align-items-center">
        <div class="flex-grow-1 overflow-hidden mr-3">
          <p class="ch-meta-label mb-0">Password</p>
          <code class="ch-wifi-code font-semibold">{{ wifi.password }}</code>
        </div>
        <button
          @click="copyWifi"
          :class="['ch-copy-btn flex-shrink-0', { 'ch-copy-btn--done': copied }]"
          type="button"
        >
          <transition name="tf" mode="out-in">
            <span v-if="copied" key="done" class="d-flex align-items-center" style="gap:5px">
              <Check :size="12" :stroke-width="3" /> Copied!
            </span>
            <span v-else key="idle">Copy</span>
          </transition>
        </button>
      </div>
    </div>

    <!-- Hotel facts -->
    <div class="bg-white radius-16 box-shadow-bold overflow-hidden mb-4">
      <div
        v-for="(fact, i) in facts"
        :key="fact.label"
        :class="['d-flex align-items-center px-3 py-3', { 'border-top': i > 0 }]"
      >
        <div class="ch-icon-box mr-3 flex-shrink-0">
          <component :is="fact.icon" :size="16" :stroke-width="2" />
        </div>
        <div class="flex-grow-1 overflow-hidden">
          <p class="ch-meta-label mb-1">{{ fact.label }}</p>
          <p class="mb-0 body-2-1" style="line-height:1.4">{{ fact.value }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Wifi, Check } from 'lucide-vue'

  export default {
    name: 'ConciergeEssentialsSection',
    components: { Wifi, Check },
    props: {
      wifi:  { type: Object, default: null },
      facts: { type: Array,  default: () => [] },
    },
    data() {
      return { copied: false }
    },
    methods: {
      copyWifi() {
        if (navigator.clipboard) navigator.clipboard.writeText(this.wifi.password).catch(() => {})
        this.copied = true
        this.$emit('toast', 'Password copied!')
        setTimeout(() => { this.copied = false }, 2000)
      },
    },
  }
</script>

<style scoped>
.ch-section-header { padding-top: 8px; }

.ch-meta-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #6B7886;
}

.ch-icon-box {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #EEF3F7;
  color: var(--merchant-primary-color, #2B5F7A);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ch-wifi-pass {
  background: #F5F8FA;
  border: 1.5px dashed #D8E4EE;
  border-radius: 10px;
  padding: 12px 14px;
}

.ch-wifi-code {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  color: #1C2B36;
}

.ch-copy-btn {
  min-width: 72px;
  padding: 9px 14px;
  border-radius: 10px;
  font-size: 11.5px;
  font-weight: 700;
  font-family: inherit;
  border: none;
  cursor: pointer;
  background: var(--merchant-primary-color, #2B5F7A);
  color: #fff;
  transition: background 0.25s, transform 0.1s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ch-copy-btn:active {
  transform: scale(0.95);
}

.ch-copy-btn--done {
  background: #27AE60;
}

/* copy text swap transition */
.tf-enter-active, .tf-leave-active { transition: opacity 0.15s, transform 0.15s; }
.tf-enter { opacity: 0; transform: translateY(4px); }
.tf-leave-to { opacity: 0; transform: translateY(-4px); }
</style>



// WEBPACK FOOTER //
// src/components/v2/ConciergeEssentialsSection.vue